"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IntegerSelectorComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _quantitySelector = _interopRequireDefault(require("@ux/quantity-selector"));
require("@ux/quantity-selector/styles");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _storeProvider = require("./../util/storeProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class IntegerSelectorComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.qtyRef = /*#__PURE__*/_react.default.createRef();
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(value, isValid) {
    const {
      handleChange,
      selectedVal,
      min,
      max
    } = this.props;
    if (isValid && value !== selectedVal && value !== '') {
      handleChange(value);
    } else if (value < min) {
      this.qtyRef.current._setValue(min, true);
    } else if (value > max) {
      this.qtyRef.current._setValue(max, true);
    } else if (value !== selectedVal) {
      this.qtyRef.current._setValue(selectedVal, true);
    }
  }
  render() {
    const {
      store
    } = this.context;
    var {
        instancePath,
        content: {
          title = '',
          errorMessage = ''
        },
        selectedVal,
        disabled,
        min,
        max
      } = this.props,
      debounceTimeout = 500;
    return /*#__PURE__*/_react.default.createElement(_quantitySelector.default, {
      ref: this.qtyRef,
      name: instancePath,
      min: min,
      max: max,
      errorMessage: errorMessage,
      defaultValue: selectedVal,
      onChange: (0, _lodash.default)(this.handleChange, debounceTimeout),
      label: /*#__PURE__*/_react.default.createElement("h5", {
        className: "mb-0"
      }, store.parseHtml(title)),
      disabled: disabled
    });
  }
}
exports.IntegerSelectorComponent = IntegerSelectorComponent;
IntegerSelectorComponent.propTypes = {
  disabled: _propTypes.default.bool,
  content: _propTypes.default.object.isRequired,
  instancePath: _propTypes.default.string.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  min: _propTypes.default.number.isRequired,
  max: _propTypes.default.number.isRequired,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number])
};
var _default = exports.default = (0, _storeProvider.provideContext)(IntegerSelectorComponent);